var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.apple_pay_btn_visible)?_c('div',[_c('button',_vm._b({attrs:{"id":"apple-pay-button","title":"Apple Pay"},on:{"click":_vm.onApplePayClick}},'button',_vm.ADAattr('label', 'Pay with Apple Pay'),false))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }